<template>
  <div class="schedule__daynavigator">
    <day-select-dropdown :selectedDate="selectedDate" @date-selected="dateSelected" mode="week">
      <template #trigger="{ toggleDropdown }">
        <a
          tooltiptext
          tabindex="0"
          class="control-icon-button arrow-button test-previous-week control-button"
          v-on:click="$emit('navigate-in-weeks', -1)"
        >
          <span class>
            <i data-icon="arrow-left" class="icon"></i>
          </span>
        </a>
        <a
          tooltiptext
          tabindex="0"
          class="this-week-button test-this-week control-button"
          @click="toggleDropdown"
        >
          <span class>
            <span v-if="(selectedWeekNumber)" class="control-button-text">Week {{ selectedWeekNumber }}</span>
          </span>
        </a>
        <a
          tooltiptext
          tabindex="0"
          class="control-icon-button arrow-button test-next-week control-button"
          v-on:click="$emit('navigate-in-weeks', 1)"
        >
          <span class>
            <i data-icon="arrow-right" class="icon"></i>
          </span>
        </a>
      </template>
    </day-select-dropdown>
  </div>
</template>

<script>
import moment from 'moment';
import DaySelectDropdown from '@/components/common/DaySelectDropdown.vue';

export default {
  name: 'schedule-day-navigator',
  components: { DaySelectDropdown },
  props: {
    selectedDate: {
      type: Date,
      required: true
    }
  },
  data: () => ({
    
  }),
  methods: {
    dateSelected(date) {
      const currentMoment = moment(this.selectedDate).isoWeekday(1),
            selectedMoment = moment(date).isoWeekday(1);
      const daysDiff = selectedMoment.diff(currentMoment, 'days');
      const weeksDiff = ((daysDiff < 0) ? daysDiff-1 : daysDiff) / 7;
      
      this.$emit('navigate-in-weeks', weeksDiff);
    }
  },
  computed: {
    selectedWeekNumber() {
      return moment.utc(this.selectedDate).week();
    }
  }

}
</script>

<style lang="scss">
.schedule__daynavigator {
  display: flex;

  .dayselectdropdown {
    .dayselectdropdown__dropdown {
      // top: -6px !important;

      .dayselectdropdown__dayspanel {
        box-shadow: 0 2px 10px rgb(0 0 0 / 20%);
      }
    }
  }
}
</style>
